$(window).on("load",function(){

  $("#loader").fadeOut(1000);
  $(".span3 img").css("opacity","0");
  $(".pro_dec_remove").hide();
  $(".rc_block__type__autodeliver").find("input").trigger("click");
});
$(".add_btn_pro").on("click",function(){

  var img_src ;
  var pro_id ;
  var product_id_click;
  var titl_pro;
  $(".remover").css({"opacity":"1", "pointer-events":"all"});
  $(".crosel_prod").slideDown( "slow" );
  $(".crosel_prod").show(1500);
  $(".btn_remove").show();

  plus_pro_sub_1();
  plus_pro_sub_2();
  product_id_click = $(this).attr("product_btn_id");
  switch (product_id_click) { 

    case '7681543405611': 
      img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Electric_unit_horizontal.png";
      pro_id = "7681543405611";
      titl_pro = "E-UNIT, $60.00";
      break;
    case '7907004186667': 
      img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Head_brush_horizontal.png";
      pro_id = "7907004186667";
      titl_pro = "ELECTRIC, $4.00";
      break;
    case '7681634926635': 
      img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Classic.png";
      pro_id = "7681634926635";
      titl_pro = "CLASSIC, $4.00";

      break;		
    case '7681673658411': 
      img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Kids.png";
      pro_id = "7681673658411";
      titl_pro = "KIDS, $4.00";
      break;
    default:
      img_src ='';
      pro_id ='';
  }

  $(".custome_slider_product .span3 .thumbnail .pro_img").each(function(){

    var img_src_chck = $(this).attr("src");
    var img_no = $(this).attr("img_no");
    if(img_no == "5")
    {
      $(".carousel-indicators").find("li:nth-child(2)").trigger("click");
      $(".nudge__control.nudge__control--left").css("opacity","1");
    }
    else if(img_no == "9")
    {
      $(".carousel-indicators").find("li:nth-child(3)").trigger("click");
      $(".nudge__control.is-disabled").css("opacity","1");
    }
    else if(img_no == "11")
    {
      max_10();
      die();
      return false;
    }

    if(img_src_chck == "")
    {
      $(this).parent().find(".pro_dec_remove").show();
      $(".pro_dec_remove").css( "opacity","0");
      $(this).css("opacity","1"); 
      $(this).attr("src",img_src);
      $(this).attr("product_main_id",pro_id);
      $(this).attr("var_main_pro_id_get",pro_id);
      $(this).parent().parent().find(".brush-list__item__data__title").css("display","block"); 
      $(this).parent().parent().find(".brush-list__item__data__title").text(titl_pro);

      if(product_id_click == "7681634926635" || product_id_click == "7681673658411")
      {
        $(this).parent().parent().find(".brush-list__item__controls").css("display","block"); 
      }
      die();
      return false; 
    }

  });

});

$(".brush-list__item__controls").find(".color-radio").on("click",function(){
  var variant_img_src;
  var variant_img_pro_id;
  var prod_main_selec_variant_pro = $(this).parent().parent().find(".pro_img").attr("var_main_pro_id_get");
  var select_color_variant = $(this).attr("data-color-changer");
  $(this).parent().each(function(){
    $(this).find(".color-radio").removeClass("is-selected");
  });
  $(this).addClass("is-selected");


  if(prod_main_selec_variant_pro == '7681634926635')
  { 
    if(select_color_variant== 'White')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Electric_unit_horizontal.png";
      variant_img_pro_id = "7681634926635";
    }
    else if (select_color_variant== 'Orange')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Head_brush_horizontal.png";
      variant_img_pro_id = "7751673479211";
    }
    else if (select_color_variant== 'Mint')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Classic.png";
      variant_img_pro_id = "7751673511979";
    }
    else if (select_color_variant== 'Blue')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Kids.png";
      variant_img_pro_id = "7751673544747";
    }

  }
  else if(prod_main_selec_variant_pro == '7681673658411'){

    if(select_color_variant== 'Mint')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Head_brush_horizontal.png";
      variant_img_pro_id = "7681673658411";
    }
    else if (select_color_variant== 'Coral')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Kids.png";
      variant_img_pro_id = "7751744585771";
    }
    else if (select_color_variant== 'Tangerine')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Head_brush_horizontal.png";
      variant_img_pro_id = "7751744618539";
    }
    else if (select_color_variant== 'Blueberry')
    {
      variant_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Electric_unit_horizontal.png";
      variant_img_pro_id = "7751744684075";
    }


  }

  $(this).parent().parent().find(".pro_img").attr("product_main_id",variant_img_pro_id);
  $(this).parent().parent().find(".pro_img").attr("src",variant_img_src);
});

function remove_pro( obj){
  $(obj).parent().parent().find(".pro_img").attr("src","");
  $(obj).parent().parent().find(".pro_img").attr("product_main_id","");
  $(obj).parent().parent().find(".pro_img").css("opacity","0");
  $(obj).parent().parent().parent().find(".brush-list__item__data__title").css("display","none");
  $(obj).parent().parent().parent().find(".brush-list__item__controls").css("display","none");
  $(obj).hide();

  min_pro_sub_1();
  min_pro_sub_2();
  var remv_img_no = $(obj).parent().parent().find(".pro_img").attr("img_no");
  var array_scr_val =[];
  $(".custome_slider_product .span3 .thumbnail .pro_img").each(function(){
    var img_src_chck_remv = $(this).attr("src");
    //    var img_no_remov = $(this).attr("img_no");
    //    if(img_src_chck_remv != "")
    //    {
    //    if(img_no_remov == "1" && img_no_remov == "2" && img_no_remov == "3" && img_no_remov == "4" )
    //    {
    //    $(".carousel-indicators").find("li:nth-child(2)").trigger("click");
    //    }
    //    }
    if(img_src_chck_remv !="")
    {
      var yes_src = "1"
      array_scr_val.push(yes_src);
    }
  }); 
  if(array_scr_val.length == 0)
  {
    $(".crosel_prod").slideUp( "slow" );
    $(".crosel_prod").hide(1500);
    $(".adders").css({"opacity":"1", "pointer-events":"all"});
    $(".pro_dec_remove").css( "opacity","0");
    $(".button--continue").css("display","none");
  }
}

function fist_btn_click(){
  $(".fist_btn_click").slideUp( "slow" );
  $(".fist_btn_click").hide(1500);
  $(".step_first_buold_your_own").css("display","block");
}

function choose_kit(){
  $(".step_first_buold_your_own").hide();
  $(".fist_btn_click").slideDown("slow");
  $(".fist_btn_click").show(1500);
}

function remove_btn_pro_min(){
  $(".adders").css({"opacity":".3", "pointer-events":"none"});
  $(".pro_dec_remove").css( "opacity","1");
  $(".button--continue").css("display","block");
  $(".btn_remove").hide();
}

function continue_btn_pro_min(){
  $(".adders").css({"opacity":"1", "pointer-events":"all"});
  $(".pro_dec_remove").css( "opacity","0");
  $(".button--continue").css("display","none");
  $(".btn_remove").show();
}

function right_click_btn(){
  $(".refrenve_click_right").trigger("click");
}

function min_pro_sub_1(){
  var pro_1_val = parseInt($(".value_pro_chng").text());
  if(pro_1_val!= "0")
  {
    var new_pro_1_val = pro_1_val - 1;
    $(".value_pro_chng").text(new_pro_1_val);
    $(".pro_tootpaste_first").attr("toothpaste_pro_1_qty",new_pro_1_val);
  }
  var plus_pro_sub_2_qty_val = $(".pro_tootpaste_second").attr("toothpaste_pro_2_qty");
  if(pro_1_val<= 1 && plus_pro_sub_2_qty_val == "0")
  {
    // $(".next-step").css({"opacity": ".3", "pointer-events": "none"});
  }

}

function plus_pro_sub_1(){
  $(".next-step").css({"opacity": "1", "pointer-events": "all"});
  var pro_1_val = parseInt($(".value_pro_chng").text());
  var new_pro_1_val = pro_1_val + 1;
  if(new_pro_1_val != "11")
  {
    $(".value_pro_chng").text(new_pro_1_val);
    $(".pro_tootpaste_first").attr("toothpaste_pro_1_qty",new_pro_1_val);
  }
  else
  {
    max_10();
  }

}

function min_pro_sub_2(){
  var pro_2_val = parseInt($(".value_pro_chng_2").text());
  if(pro_2_val!= "0")
  {
    var new_pro_2_val = pro_2_val - 1;
    $(".value_pro_chng_2").text(new_pro_2_val);
    $(".pro_tootpaste_second").attr("toothpaste_pro_2_qty",new_pro_2_val);
  }
  var plus_pro_sub_1_qty_val = $(".pro_tootpaste_first").attr("toothpaste_pro_1_qty");
  if(pro_2_val<= 1 && plus_pro_sub_1_qty_val== "0")
  {
    // $(".next-step").css({"opacity": ".3", "pointer-events": "none"});
  }

}

function plus_pro_sub_2(){
  $(".next-step").css({"opacity": "1", "pointer-events": "all"});
  var pro_2_val = parseInt($(".value_pro_chng_2").text());
  var new_pro_2_val = pro_2_val + 1;
  if(new_pro_2_val !="11")
  {
    $(".value_pro_chng_2").text(new_pro_2_val);
    $(".pro_tootpaste_second").attr("toothpaste_pro_2_qty",new_pro_2_val);
  }
  else
  {
    max_10();
  }
}

function checkout_popup() {
  var product_id;
  var stor_pro_id_arry = [];
  var product_main_id_final_simple;
  $(".custome_slider_product .span3 .thumbnail .pro_img").each(function(index){

    var product_main_id_final = $(this).attr("product_main_id");

    if(product_main_id_final != "")
    {

      switch (product_main_id_final) { 

          // this is case for CLASSIC TOOTHBRUSH subscription
        case '7681634926635': 
          // this is used for MINT CLASSIC TOOTHBRUSH
          addItemToCart_Subs(7681634926635,1,'90','Days','97693');
          break;

        case '7751673479211': 
          // this is used for Coral CLASSIC TOOTHBRUSH
          addItemToCart_Subs(7751673479211,1,'90','Days','97693');
          break;

        case '7751673511979': 
          // this is used for Tangerine CLASSIC TOOTHBRUSH
          addItemToCart_Subs(7751673511979,1,'90','Days','97693');
          break;	

        case '7751673544747': 
          // this is used for Blueberry CLASSIC TOOTHBRUSH
          addItemToCart_Subs(7751673544747,1,'90','Days','97693');
          break;

          // this is case for KIDS TOOTHBRUSH subscription
        case '7681673658411': 
          // this is used for MINT FLOSS
          addItemToCart_Subs(7681673658411,1,'90','Days','97693');
          break;

        case '7751744585771': 
          // this is used for Coral FLOSS
          addItemToCart_Subs(7751744585771,1,'90','Days','97693');
          break;

        case '7751744618539': 
          // this is used for Tangerine FLOSS
          addItemToCart_Subs(7751744618539,1,'90','Days','97693');
          break;	

        case '7751744684075': 
          // this is used for Blueberry FLOSS
          addItemToCart_Subs(7751744684075,1,'90','Days','97693');
          break;

        default:
          product_main_id_final_simple = product_main_id_final;

      }
      if ($.inArray(product_main_id_final_simple, stor_pro_id_arry) == -1)
      {
        stor_pro_id_arry.push(product_main_id_final_simple); 
      }
    }
  });

  for(var i =0; i<=stor_pro_id_arry.length; i++)
  {
    product_id = stor_pro_id_arry[i];

    $.ajax({
      type: "POST",
      async:false,
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: product_id
      },
      dataType: "json",
      success:function(result)
      {
      },
      complete: function() {
        // window.location = "/cart/";

      }

    });
  }

  var product_toot_paste_first_id = "8164878450731";
  var product_toot_paste_first_qty = $(".pro_tootpaste_first").attr("toothpaste_pro_1_qty");
  var product_toot_paste_second_id = "7907208626219";
  var product_toot_paste_second_qty = $(".pro_tootpaste_second").attr("toothpaste_pro_2_qty");

  if(product_toot_paste_first_qty != "")
  {
    // this is used for MINT FLOSS
    addItemToCart_Subs(8164878450731,product_toot_paste_first_qty,'90','Days','97693');
  }
  if(product_toot_paste_second_qty != "")
  {
    // this is used for ELA MINT TOOTHPASTE $7
    addItemToCart_Subs(7907208626219,product_toot_paste_second_qty,'90','Days','97693');

  }
  //   popup
  var modal_custom = document.getElementById('mymodal_custom');

  var modal_customImg = document.getElementById("pop_upStyle");
  //var captionText = document.getElementById("caption");
  modal_custom.style.display = "block";
  $(".modal__inner").animate({top: '30px'})
  var span = document.getElementsByClassName("amount-button--close")[0];

  span.onclick = function() { 
    modal_custom.style.display = "none";
  }
}

function show_addon_variant(){
  // $(".image_final_pro_first").attr("addon_pro_first_id","7778199765035");
  if ($(".image_final_pro_first").attr("addon_pro_first_id")) {
    $(".image_final_pro_first").removeAttr('addon_pro_first_id');
  } else {
    $(".image_final_pro_first").attr('addon_pro_first_id',"7778199765035");
  }
  $(".first_img_addon").toggleClass("is-selected");
}

function show_addon_variant_second(){
  if ($(".image_final_pro_secnd").attr("addon_pro_second_id")) {
    $(".image_final_pro_secnd").removeAttr('addon_pro_second_id');
  } else {
    $(".image_final_pro_secnd").attr('addon_pro_second_id',"7793164681259");
  }
  $(".second_img_addon").toggleClass("is-selected");
}

$(".addon_radio_varant").find(".color-radio").on("click",function(){
  var addon_pro_first_id = $(".image_final_pro_first").attr("addon_pro_first_id");
  var data_color_changer_variant;
  var var_addon_img_src;

  $(".addon_radio_varant").each(function(){
    $(this).find(".color-radio").removeClass("is-selected");
  });
  $(this).addClass("is-selected");
  data_color_changer_variant = $(this).attr("data-color-changer");
  if(data_color_changer_variant == "Mint")
  {
    addon_pro_first_id = "7778199765035"; 
    var_addon_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/addons_classic.png";
  }
  else  if(data_color_changer_variant == "Coral")
  {
    addon_pro_first_id = "7778199830571";
    var_addon_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Kids.png";
  }
  else  if(data_color_changer_variant == "Tangerine")
  {
    addon_pro_first_id = "7778199863339"; 
    var_addon_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/brush-mask-Classic.png";
  }
  else  if(data_color_changer_variant == "Blueberry")
  {
    addon_pro_first_id = "7778199928875"; 
    var_addon_img_src = "https://cdn.shopify.com/s/files/1/2656/6094/files/Head_brush_horizontal.png";
  }

  $(".image_final_pro_first").attr("addon_pro_first_id",addon_pro_first_id);
  $(".image_final_pro_first").attr("src",var_addon_img_src);

});


function final_checkout(){
  $(".chckot_fnl").css("display","none");
  $(".second_chkou_anim").css("display","block");
  var addon_pro_first_id_final_first = $(".image_final_pro_first").attr("addon_pro_first_id");
  var addon_pro_first_id_final_second = $(".image_final_pro_secnd").attr("addon_pro_second_id"); 

  if(addon_pro_first_id_final_first !="")
  { 
    $.ajax({
      type: "POST",
      async:false,
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: addon_pro_first_id_final_first
      },
      dataType: "json",
      success:function(result)
      {
      },
      complete: function() {
        // window.location = "/cart/";

      }
    });

  } 
  if(addon_pro_first_id_final_second !="")
  {
    $.ajax({
      type: "POST",
      async:false,
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: addon_pro_first_id_final_second
      },
      dataType: "json",
      success:function(result)
      {
      },
      complete: function() {

      }
    });
  }
  window.location = "/cart/";
}
$(".last_radio_btn").find(".color-radio").on("click",function(){
  $(".last_radio_btn").each(function(){
    $(this).find(".color-radio").removeClass("is-selected");
  });
  $(this).addClass("is-selected");

});
function no_thanku(){
  $(".show_after_click_thnk").css("display","block");
  $(".hide_after_click_thnk").css("display","none");
}
//popup classic
function classic_modal(){

  var classic_modal = document.getElementById('clasic_modal');
  var modal_customImg = document.getElementById("pop_upStyle");
  var captionText = document.getElementById("caption");
  classic_modal.style.display = "block";
  $(".modal__inner").animate({top: '30px'});
}
function close_clacik_popup(){
  $("#clasic_modal").css("display","none")

}
// popup kids
function kids_modal(){
  var classic_modal = document.getElementById('kids_modal');
  var modal_customImg = document.getElementById("pop_upStyle");
  var captionText = document.getElementById("caption");
  classic_modal.style.display = "block";
  $(".modal__inner").animate({top: '30px'});
}
function close_kids_popup(){
  $("#kids_modal").css("display","none")
}
// floss model
function floss_modal(){
  var classic_modal = document.getElementById('floss_modal');
  var modal_customImg = document.getElementById("pop_upStyle");
  var captionText = document.getElementById("caption");
  classic_modal.style.display = "block";
  $(".modal__inner").animate({top: '30px'});
}
function close_floss_popup(){
  $("#floss_modal").css("display","none")
}
// toothpaste_modal
function toothpaste_modal(){
  var classic_modal = document.getElementById('toothpaste_modal');
  var modal_customImg = document.getElementById("pop_upStyle");
  var captionText = document.getElementById("caption");
  classic_modal.style.display = "block";
  $(".modal__inner").animate({top: '30px'});
}
function close_toothpaste_modal(){
  $("#toothpaste_modal").css("display","none")
}
// Max_10
function max_10(){
  var classic_modal = document.getElementById('max_10');
  var modal_customImg = document.getElementById("pop_upStyle");
  var captionText = document.getElementById("caption");
  classic_modal.style.display = "block";
  $(".modal__inner").animate({top: '30px'});
}
function close_max_10(){
  $("#max_10").css("display","none")
}